
import { mapGetters } from 'vuex';
import MutualRecommendationWidget from '@/components/widgets/MutualRecommendationWidgetWrapper';
import CompanyFollowersWidget from '@/components/widgets/CompanyFollowersWidgetWrapper';
import DataTickerWidgetWrapper from '~/components/widgets/DataTickerWidgetWrapper.vue';
import TrendingLosersTickersWidgetWrapper from '~/components/widgets/TrendingLosersTickersWidgetWrapper.vue';
import TrendingGainersTickersWidgetWrapper from '~/components/widgets/TrendingGainersTickersWidgetWrapper.vue';
import TrendingCryptosWidgetWrapper from '~/components/widgets/TrendingCryptosWidgetWrapper';
import SimilarCompaniesWidgetWrapper from '~/components/widgets/SimilarCompaniesWidgetWrapper.vue';
import TrendingIndicesWidgetWrapper from '~/components/widgets/TrendingIndicesWidgetWrapper.vue';
import { appURLs } from '@/utils/route-redirects';
import CompanyDescriptionWidget from '~/components/widgets/CompanyDescriptionWidget.vue';

export default {
  name: 'Widgets',
  components: {
    MutualRecommendationWidget,
    CompanyFollowersWidget,
    DataTickerWidgetWrapper,
    TrendingLosersTickersWidgetWrapper,
    TrendingGainersTickersWidgetWrapper,
    TrendingCryptosWidgetWrapper,
    SimilarCompaniesWidgetWrapper,
    TrendingIndicesWidgetWrapper,
    CompanyDescriptionWidget,
  },
  computed: {
    ...mapGetters('authentication', {
      authProfile: 'profile',
      profileId: 'profileId',
    }),
    ...mapGetters('profile', ['profile']),
    routeName() {
      // TODO from Nikola: use appURLs or routeNames
      return this.$route.name?.split('_')[0];
    },
    routeParams() {
      return this.$route.params;
    },
    showGainerLoserTickersWidget() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        [appURLs.feed(), 'search-hashtags', 'markets'].indexOf(
          this.routeName
        ) != -1 ||
        this.isCompanyProfile ||
        this.isSearchResults
      );
    },
    showDataTickerWidget() {
      // TODO from Nikola: use appURLs or routeNames
      return ['profile-profile-symbol'].indexOf(this.routeName) != -1;
    },
    showIndiceWidget() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        ([appURLs.feed(), 'markets'].indexOf(this.routeName) != -1 &&
          this.authProfile &&
          this.routeName !== '') ||
        this.isSearchResults
      );
    },
    showPopularCryptoWidget() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        (this.authProfile &&
          this.authProfile.isSuscribedToCrypto &&
          [appURLs.feed(), 'search-hashtags', 'crypto'].indexOf(
            this.routeName
          ) != -1) ||
        this.isSearchResults
      );
    },
    showRecommendationWidget() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        [
          appURLs.feed(),
          'search-hashtags',
          'saved',
          'markets',
          'post-postId',
          'portfolios-portfolio-comments',
        ].indexOf(this.routeName) != -1 ||
        this.isUserProfile ||
        this.isSearchResults
      );
    },
    showCryptosWidget() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        this.authProfile &&
        this.authProfile.isSuscribedToCrypto &&
        ([appURLs.feed(), 'search-hashtags', 'crypto'].indexOf(
          this.routeName
        ) != -1 ||
          this.isCryptoProfile ||
          this.isSearchResults)
      );
    },
    showSimilarCompaniesWidget() {
      return this.isCompanyProfile;
    },
    showCompanyFollowersWidget() {
      return this.isCompanyProfile;
    },
    isCryptoProfile() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        ['profile-profileId'].indexOf(this.routeName) != -1 &&
        this.profile &&
        this.profile.profileType == 'CryptocurrencyProfile'
      );
    },
    isCompanyProfile() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        ['profile-profileId'].indexOf(this.routeName) != -1 &&
        this.profile &&
        this.profile.profileType == 'CompanyProfile'
      );
    },
    isCompanyTypeStock() {
      // TODO from Nikola: use appURLs or routeNames
      return (
        ['profile-profileId'].indexOf(this.routeName) != -1 &&
        this.profile &&
        this.profile.profileType == 'CompanyProfile' &&
        this.profile.companyType == 'Stock'
      );
    },
    hasCompanyDescription() {
      return this.profile?.description?.length > 0;
    },
    isUserProfile() {
      return (
        ['profile-profileId'].indexOf(this.routeName) != -1 &&
        this.profile &&
        this.profile.profileType == 'PersonalProfile'
      );
    },
    isHomeFeed() {
      return this.routeName === appURLs.feed();
    },
    isSearchResults() {
      return this.routeName === appURLs.searchResults();
    },
    isTickerProfile() {
      // TODO from Nikola: use appURLs or routeNames
      return this.routeName === 'profile-profile-symbol';
    },
  },
};
